const YEAR_REGEX = /{ANNEE}/g;

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

function yearStrategy(contentBlock, callback, contentState) {
  findWithRegex(YEAR_REGEX, contentBlock, callback);
}

const Year = (props) => {
  const getFullYear = new Date().getFullYear();
  return getFullYear;
};

export const YearDecorator = {
  strategy: yearStrategy,
  component: Year,
};
